import { AnalyticsDirective } from './analytics';

export const ALL_DIRECTIVES = [
    AnalyticsDirective,
];
